import { components } from "bri-vtools";
import home from "./modules/home.js";
import introduction from "./modules/introduction.js";
import exportPage from "./modules/exportPage.js";

const routes = [
    {
        path: "/",
        name: "home",
        meta: {
            title: "主页"
        },
        component: () => import("@/views/home/home.vue"),
        children: home
    },
    introduction,
    exportPage,
    // 检测是否登录页面
    {
        path: "/checkLogin",
        name: "checkLogin",
        meta: {
            title: "检测",
            norpermission: true
        },
        component: () => import("@/pages/Sso/checkLogin.vue")
    },
    // 登录页面
    {
        path: "/login",
        name: "login",
        meta: {
            title: "登录",
            norpermission: true
        },
        component: () => import("@/pages/Sso/login.vue")
    },
    // 退出页面
    {
        path: "/logout",
        name: "logout",
        meta: {
            title: "退出",
            norpermission: true
        },
        component: () => import("@/pages/Sso/logout.vue")
    },
    // 注册页面
    {
        path: "/register9527",
        name: "register",
        meta: {
            title: "注册",
            norpermission: true
        },
        component: () => import("@/pages/Register/Register.vue")
    },
    // 错误页面
    {
        path: "/500",
        name: "500",
        meta: {
            title: "500"
        },
        component: components.Error500
    },
    {
        path: "/403",
        name: "403",
        meta: {
            title: "403"
        },
        component: components.Error403
    },
    {
        path: "/*",
        name: "404",
        meta: {
            title: "404"
        },
        component: components.Error404
    }
];

export {
    routes
};



// WEBPACK FOOTER //
// ./src/router/routes.js